// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueAnalytics from 'vue-ua'
import VueFire from 'vuefire'
import Firebase from 'firebase'
import App from './components/layouts/App'
import Home from './components/pages/Home'
import Video from './components/pages/Video'
import Facebook from './components/pages/Facebook'
import Help from './components/pages/Help'
import Bpmn from './components/pages/Bpmn'
import MovieTimeAndTicket from './components/pages/MovieTimesAndTickets'
import Movies from './components/pages/Movies'
import TV from './components/pages/TV'
import NewOnDVD from './components/pages/NewOnDVD'

import '../node_modules/semantic-ui/dist/semantic.css'
// import 'expose-loader?$!expose-loader?jQuery!jquery'

// import semantic from 'semantic'

Vue.use(VueFire)
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueAnalytics, {
  appName: 'spinoff-vue', // Mandatory
  appVersion: '0.1.0', // Mandatory
  trackingId: 'UA-292579-4', // Mandatory
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ['homepage'], // If router, you can exclude some routes name (case insensitive) (optional)
  globalDimensions: [ // Optional
    { dimension: 1, value: 'MyDimensionValue' },
    { dimension: 2, value: 'AnotherDimensionValue' }
  ],
  globalMetrics: [ // Optional
    { metric: 1, value: 'MyMetricValue' },
    { metric: 2, value: 'AnotherMetricValue' }
  ]
})

const NotFound = { template: '<p>Page not found</p>' }

const store = new Vuex.Store({
  state: {
    count: 0,
    authUser: null
  },
  mutations: {
    increment (state) {
      state.count++
    }
  }
})

const routes = [
  { path: '/', component: Home },
  { path: '/movie-times-and-tickets', component: MovieTimeAndTicket },
  { path: '/movies', component: Movies },
  { path: '/tv', component: TV },
  { path: '/new-on-dvd', component: NewOnDVD },
  { path: '/videos', component: Video },
  { path: '/home', component: Home },
  { path: '/facebook', component: Facebook },
  { path: '/not_found', component: NotFound },
  { path: '/help', component: Help },
  { path: '/bpmn', component: Bpmn }
]

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes
})

const firebaseApp = Firebase.initializeApp({
  apiKey: 'AIzaSyC0wPWhT1rpqnl_51nYNI_tsxb0Sz9WZNc',
  authDomain: 'popping-inferno-7199.firebaseapp.com',
  databaseURL: 'https://popping-inferno-7199.firebaseio.com',
  storageBucket: 'popping-inferno-7199.appspot.com',
  messagingSenderId: '1069734382415'

})
const db = firebaseApp.database()

const app = new Vue({
  router,
  firebase: {
    anArray: db.ref('channels'),
    anObject: {
      source: db.ref('-KH3M8S6nitvLjccILhZ'),
      asObject: true,
      cancelCallback: function() {}
    }
  },
  template: '<App />',
  components: { App }
}).$mount('#app')

export { app, router, store }



// WEBPACK FOOTER //
// ./src/main.js